import { forwardRef, type ButtonHTMLAttributes } from 'react';

import { cn } from '../lib/cn';

export type SwitchProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> & {
  checked: boolean;
  onCheckedChange?: (checked: boolean) => void;
};

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(function Switch(
  { checked, onCheckedChange, className, disabled, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => {
        if (disabled) return;
        onCheckedChange?.(!checked);
      }}
      className={cn(
        'inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition-colors',
        checked
          ? 'border-transparent bg-[var(--accent)]'
          : 'border-[var(--border)] bg-[var(--bg)]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <span
        className={cn(
          'h-3.5 w-3.5 rounded-full bg-white shadow-[0_1px_2px_rgba(0,0,0,0.2)] ring-1 ring-inset ring-[var(--border)] transition-all duration-150 ease-in-out',
          checked && 'shadow-[0_1px_3px_rgba(0,0,0,0.3)]'
        )}
        style={{ transform: `translateX(${checked ? 18 : 2}px)` }}
      />
    </button>
  );
});

Switch.displayName = 'Switch';
